import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { projectViewFreelancerProjectsBackend } from './project-view-freelancer-projects.backend';
import { projectViewFreelancerProjectsReducer } from './project-view-freelancer-projects.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'projectViewFreelancerProjects',
      projectViewFreelancerProjectsReducer,
    ),
    BackendModule.forFeature(
      'projectViewFreelancerProjects',
      projectViewFreelancerProjectsBackend,
    ),
  ],
})
export class DatastoreProjectViewFreelancerProjectsModule {}
